import { commonEnvironment } from './common.environment';

export const environment = {
  ...commonEnvironment,
  production: true,
  preventFormUnload: true,
  sentry: '',
  envName: 'prod',
  enableServiceWorker: true,
  serverApiUrl: 'https://host',
  authServerUrl: 'https://auth.cloud.triarc-labs.com/auth',
};
